class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select')).map((select) => select.value);
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    this.currentVariant = variantData.find((variant) => 
      variant.options.every((option, index) => this.options[index] === option)
    );
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;

    const parent = newMedia.parentElement;
    parent.prepend(newMedia);

    const stickyImage = document.getElementById('sticky-product-image');
    if (stickyImage) stickyImage.src = newMedia.querySelector('img').src;

    const mediaIndex = newMedia.closest('[data-media-id]')?.getAttribute('data-media-index');
    if (mediaIndex !== null) {
      $('.slider-for').slick('slickGoTo', mediaIndex);
    }

    setTimeout(() => parent.scroll(0, 0), 0);
  }

  updateURL() {
    if (this.currentVariant) {
      const newUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      window.history.replaceState({}, '', newUrl);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(responseText, 'text/html');

        const priceElement = document.getElementById(`price-${this.dataset.section}`);
        const newPriceElement = html.getElementById(`price-${this.dataset.section}`);
        if (priceElement && newPriceElement) {
          priceElement.innerHTML = newPriceElement.innerHTML;
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.updateProductImage(html);
        this.updateStickyPrice();
      });
  }

  updateStickyPrice() {
    const newPrice = document.querySelector('.new_custom_price')?.innerHTML;
    if (newPrice) {
      document.querySelectorAll('.add-to-cart-sticky .new_custom_price').forEach((priceElement) => {
        priceElement.innerHTML = newPrice;
      });
    }
  }

  updateProductImage(html) {
    const newImage = html.querySelector('.product__media-list.slider-for .product__media-item img');
    if (!newImage) return;

    const mainImage = document.querySelector('.product__media-list.slider-for .product__media-item img');
    const navImage = document.querySelector('.product__media-list.slider-nav .product__media-item img');
    const stickyImage = document.getElementById('sticky-product-image');

    if (mainImage) mainImage.outerHTML = newImage.outerHTML;
    if (navImage) navImage.outerHTML = newImage.outerHTML;
    if (stickyImage) stickyImage.src = newImage.src;
  }

  toggleAddButton(disable = true, text = '', modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (addButton) addButton.textContent = window.variantStrings.unavailable;

    const priceElement = document.getElementById(`price-${this.dataset.section}`);
    if (priceElement) priceElement.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (!this.variantData) {
      const dataElement = this.querySelector('[type="application/json"]');
      this.variantData = dataElement ? JSON.parse(dataElement.textContent) : [];
    }
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = fieldset.querySelector('input:checked');
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
